import { Link, Box, OrderedList, ListItem, Code, Heading, Text } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { BlogURL } from "../utils/urls";

export default function Manual({ network }) {
    function getNetworkName() {
        if (network === "mainnet") return "Polygon メインネット";
        if (network === "testnet") return "Polygon テストネット";
        if (network === "local") return "localhost:8545";
        return "不明なネットワーク";
    }
    return (
        <Box p="5" borderWidth="3px" borderRadius="lg" borderColor="yellow.200" bg="yellow.50" boxShadow="md">
            <Heading size="md" mb="3">
                NFTを飼って育てよう！
            </Heading>
            <OrderedList>
                <ListItem>
                    <Code fontWeight="bold">Connect Wallet</Code> で{getNetworkName()}に接続してください。
                </ListItem>
                <ListItem>
                    名前を入力して <Code fontWeight="bold">Claim</Code> すると、新しくNFTを飼うことができます。
                </ListItem>
                <ListItem>NFTの初期ライフは100です。</ListItem>
                <ListItem>ライフは1時間に1減ります。</ListItem>
                <ListItem>
                    <Code fontWeight="bold">Feed</Code> でエサをやるとライフは100に回復します。
                </ListItem>
                <ListItem>ライフが0になると死んでしまいます。</ListItem>
                <ListItem>長くかわいがってください。</ListItem>
            </OrderedList>
            <Text mt="3">
                ※ <Code fontWeight="bold">Claim</Code>と<Code fontWeight="bold">Feed</Code> はガス代のみ必要です。
            </Text>
            <Text mt="3" fontSize="xs">
                詳しい説明は
                <Link href={BlogURL} isExternal>
                    ブログ記事
                    <ExternalLinkIcon mx="2px" />
                </Link>
                を見てください。
            </Text>
        </Box>
    );
}
